import { Component, OnInit } from '@angular/core';
import { BehaviorSubject, Subject } from 'rxjs';
import { UigEtilizeRedirectAdapter } from './uig-etilize-redirect.adapter';

@Component({
    selector: 'app-uig-etilize-redirect',
    templateUrl: './uig-etilize-redirect.component.html',
    styleUrls: ['./uig-etilize-redirect.component.scss'],
    standalone: false
})
export class UigEtilizeRedirectComponent implements OnInit {

  loading$ = new BehaviorSubject(true);

  constructor(private adapter: UigEtilizeRedirectAdapter) { }

  ngOnInit(): void {
    this.adapter
      .getRedirectUrl()
      .subscribe(
        data => {
          window.location.href = data;
        },
        error => {
          this.loading$.next(false);
        }
      );
  }

}
